import { Injectable } from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {FileSelectorModel} from '@features/file-manager/models/file-selector.model';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {DialogModel} from '@shared/models/dialog.model';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Configuration} from '@shared/models/configuration';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {take} from 'rxjs/operators';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';

@Injectable({
  providedIn: 'root'
})
export class AddFilesInPowerBiSchemaGraphCommandHandler implements IPlatformCommandHandler{

  constructor(private dialogService: DialogService,
              private platformQueryService: PlatformQueryService,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const dialogModel = DialogModel.create(`Add Data Source`, 'SelectDataMappingSourceDialogComponent', {returns: 'list'}, '400px', '400px');
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res && res.action === 'OK') {
        const query = new PlatformQuery();
        query.api = 'FileStoreApi';
        query.name = 'FieldSelectionViewModelQuery';
        if (res.data.input.selectedSource) {
          command.fieldValues['SelectedSource'] = res.data.input.selectedSource;
          query.fieldValues['SelectedSource'] = res.data.input.selectedSource;
        }
        if (res.data.input.relativePath) {
          command.fieldValues['SelectedSourceRelativePaths'] = res.data.input.relativePath;
          command.fieldValues['SelectedSourceFileNames'] = res.data.input.fileName;
          query.fieldValues['RelativePaths'] = res.data.input.relativePath;
        }
        this.platformQueryService.executeQuery(query).subscribe(response => {
          if (response.fieldValues['FieldSelectionViewModels']) {
            const selectFieldDialog = DialogModel.create(`Add Data Source`, 'SelectFieldsDialogComponent',
              {fieldSelectionViewModels: response.fieldValues['FieldSelectionViewModels']}, '600px', '600px');
            this.dialogService.showOkCancelDialog(selectFieldDialog).subscribe(dialogResponse => {
              if (dialogResponse && dialogResponse.action === 'OK') {
                command.fieldValues['SelectedFieldKeys'] = dialogResponse.data.input.selectedFieldKeys;
                this.executeCommandToApi(command, handler);
              }
            });
          }
        });
      }
    });
    return false;
  }
  executeCommandToApi(command: PlatformCommand, handler: IPlatformToolHandler) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
          }
          handler.invalidateSubject.invalidate('Refresh');
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }
}
